export default {
  id: null,
  regulationAutoID: null,
  bodywork: null,
  repair: null,
  tapestry: null,
  painting: null,
  electrical: null,
  mechanical: null,
  third: null,
  glassware: null,
  withSuppliedParts: null,
  withoutSuppliedParts: null,
  budgeted: null,
  franchise: null,
  carDamage: null,
  status: 1,
  dateUpdate: null,
  accountIDUpdate: '',
  typeConclusionID: null,
  lossTypeID: null,
  reasonFrustration: null,
  budget: null,
  engineNumber: null,
  description: null,
  comments: null,
  surveyDate: null,
  actionDate: null,

  initialSurveyBudgetedLabor: null,
  initialSurveyApprovedLabor: null,
  insuranceBudgetedLabor: null,
  insuranceApprovedLabor: null

}



// WEBPACK FOOTER //
// ./src/views/private/inspection/typing/sinitertyping-model.js